<div class="service-grid-container copo-container ecall-off-widget">
	<div class="services-box">
		<div *ngIf="!isLoading; else loading">
			<div class="services-title-bar" translate>ecall-off.call-off-by-batch</div>
			<button type="button" mat-button color="primary" class="services-label"
				[routerLink]="['/ecall-off/ecall-off-steps']">
				<span class="button-label" translate>ecall-off.start-a-new-call-off</span>
				<mat-icon iconPositionEnd class="service-icon copo-small-icon-button" svgIcon="plus_icon"></mat-icon>
			</button>
		</div>
		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>
	</div>
	<div class="services-box" *ngIf="canCallByVolume">
		<div *ngIf="!isLoading; else loading">
			<div class="services-title-bar" translate>ecall-off.call-off-by-volume</div>
			<button type="button" mat-button color="primary" class="services-label"
				[routerLink]="['/ecall-off/ecall-off-by-volume-steps']">
				<span class="button-label" translate>ecall-off.start-a-new-call-off</span>
				<mat-icon iconPositionEnd class="service-icon copo-small-icon-button" svgIcon="plus_icon"></mat-icon>
			</button>
		</div>
		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>
	</div>
</div>